import { ServerService } from '../../ts/services/ServerService';
import { ServiceLocator } from '../ServiceLocator';

export function isPhoneSizedScreen() {
  const serverService = ServiceLocator.get<ServerService>('ServerService');
  return Math.min(screen.width, screen.height) <= serverService.dsdPhoneSize();
}
